export default __webpack_public_path__ + "static/media/group-search.aadc8282.svg";